import FiltersByPeriod from './FiltersByPeriod';

export default FiltersByPeriod;
